import { Injectable } from '@angular/core';
import { DateService } from './date.service';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { GameType } from '../models/game.model';
import { set, isAfter, isBefore } from 'date-fns';
@Injectable({
  providedIn: 'root',
})
export class GameRestrictionService {
  private readonly CLOSING_TIME = { hour: 20, minute: 59 };
  private readonly OPENING_TIME = { hour: 22, minute: 40 };
  private readonly CLOSING_DRAW = { hour: 17, minute: 45 };
  private readonly OPENING_DRAW = { hour: 19, minute: 45 };
  private readonly maxAmount: number = 29999.0;

  // Son tomados de gameInfo
  // A confirmar si son los correctos
  private readonly maxPrices: { [key: string]: number } = {
    Pronosports: 2000000,
    Chispazo: 1260000,
    Ganagato: 2000,
    Melate: 3780000,
    MR: 1260000,
    Progol: 486000,
    ProgolMS: 108000,
    Protouch: 324000,
    Tris: 10000,
  };
  constructor(
    private dateService: DateService,
    private alertController: AlertController,
    private translateS: TranslateService
  ) {}

  /**
   * Verifica si la compra está permitida según la hora actual
   * @returns {boolean}
   */
  // async isPurchaseAllowed(): Promise<boolean> {
  //   const now = await this.dateService.dateNow();
  //   const currentHour = now.getHours();
  //   const currentMinute = now.getMinutes();
  //   if (
  //     (currentHour === this.CLOSING_TIME.hour && currentMinute >= this.CLOSING_TIME.minute) ||
  //     (currentHour === this.OPENING_TIME.hour && currentMinute < this.OPENING_TIME.minute) ||
  //     (currentHour > this.CLOSING_TIME.hour && currentHour < this.OPENING_TIME.hour)
  //   ) {
  //     return false;
  //   }

  //   return true;
  // }

  async isPurchaseAllowed(): Promise<boolean> {
    const isClosed = await this.dateService.verifyCloseDayIGT();
    return !isClosed;
  }

  //Validaciones de IGT
  verifyAmount(amount: number): boolean {
    if (amount > this.maxAmount) {
      this.showAlert('ALERT.ERROR', 'ALERT.EXCEEDS_LOTERIA_LIMIT');
      return false;
    }
    return true;
  }

  isValidBet(gameType: string, amount: number): boolean {
    const maxPrice = this.maxPrices[gameType];
    return maxPrice !== undefined ? amount < maxPrice : false;
  }

  async showAlert(headerKey: string, messageKey: string) {
    const header = await this.translateS.get(headerKey).toPromise();
    const message = await this.translateS.get(messageKey).toPromise();
    const acceptText = await this.translateS.get('Aceptar').toPromise();

    const alert = await this.alertController.create({
      header,
      message,
      buttons: [acceptText],
    });

    await alert.present();
  }

  validateMessageIgt(message?: any, errorRetries?: false, gameType?: GameType, noRequest?: number) {
    if (message) {
      const response = this.formatResultText(message);

      const isErrorGame = response['resultText'] === 'errorInvalidBoardData';
      const errorCategory = isErrorGame ? gameType : 'execute-response';

      let errorKey: string;
      if (response['serverErrorText']) {
        errorKey = 'serverErrorText';
      } else if (response['resultText']) {
        errorKey = response['resultText'];
      } else {
        errorKey = 'emptyError';
      }

      const errorLiability = response['resultText'] === 'errorLiability';
      noRequest = noRequest ?? 0;

      let result: string = this.translateS.instant(
        `error.${errorCategory}.${errorKey + (errorLiability ? (noRequest > 1 ? 'Multiple' : 'Alone') : '')}`
      );
      if (errorLiability && noRequest > 1) {
      }
      result = result.replace('{{drawNumber}}', response['drawNumber']);

      //console.log('MESSAGE FROM IGT: ', response['serverErrorText'] || response['resultText'] || 'No message');

      if (response['serverErrorText'] || response['resultText'] !== 'ok') {
        this.showAlert('Error', result);
      }
    } else if (errorRetries) {
      this.showAlert('ALERT.ERROR', 'ALERT.EXCEEDS_BET_LIMIT');
    }
  }
  formatResultText(text: any): { [name: string]: string } {
    if (text && typeof text === 'object' && (text.resultText !== undefined || text.serverErrorText !== undefined)) {
      return {
        serverErrorText: text.serverErrorText || '',
        resultText: text.resultText || '',
        ...text,
      };
    }

    if (text && text.executeReturn) {
      try {
        const executeReturnArray =
          text.executeReturn.executeReturn || (text.executeReturn.array ? text.executeReturn.array : []);

        const items = Array.isArray(executeReturnArray) ? executeReturnArray : [executeReturnArray];

        const result = items.reduce((acc: any, item: any) => {
          if (!item) return acc;

          const name = item.name?.$value || item.name?.attributes?.value || item.name;

          const value = item.value?.$value || item.value?.attributes?.value || item.value;

          if (name && value !== undefined) {
            acc[name] = value;
          }
          return acc;
        }, {});

        return {
          serverErrorText: result['serverErrorText'] || '',
          resultText: result['resultText'] || '',
          ...result,
          originalStructure: result['resultText'] === 'ok' ? null : text,
        };
      } catch (e) {
        console.error('Error procesando estructura SOAP:', e);
      }
    }

    console.warn('Formato de respuesta no reconocido:', text);
    return {
      serverErrorText: '',
      resultText: '',
      ...(typeof text === 'object' ? text : {}),
    };
  }
  async showClosingMessage() {
    await this.showAlert('ALERT.ERROR', 'ALERT.SALE_CLOSED_MESSAGE');
  }

  /**
   * Cierre de ventas Lotenal
   * 17:45 - 19:49 no habrá ventas ni reservaciones disponibles
   * @returns
   */
  closeDrawLotenal() {
    const dateActual = Date.now().toString();

    const now = new Date(parseInt(dateActual)).toString();

    const closingTime = set(now, {
      hours: this.CLOSING_DRAW.hour,
      minutes: this.CLOSING_DRAW.minute,
      seconds: 0,
      milliseconds: 0,
    });

    const openingTime = set(now, {
      hours: this.OPENING_DRAW.hour,
      minutes: this.OPENING_DRAW.minute,
      seconds: 0,
      milliseconds: 0,
    });

    const isClosed = isAfter(now, closingTime) && isBefore(now, openingTime);

    return isClosed;
  }
}
